import { render, staticRenderFns } from "./NavigatorItem.vue?vue&type=template&id=1f8ec1d6&lang=pug&"
import script from "./NavigatorItem.vue?vue&type=script&lang=js&"
export * from "./NavigatorItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigatorItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f8ec1d6')) {
      api.createRecord('1f8ec1d6', component.options)
    } else {
      api.reload('1f8ec1d6', component.options)
    }
    module.hot.accept("./NavigatorItem.vue?vue&type=template&id=1f8ec1d6&lang=pug&", function () {
      api.rerender('1f8ec1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NavigatorItem.vue"
export default component.exports